import dayjs, { Dayjs } from 'dayjs';

export const getTaxYears = (inputDate?: string | Date | Dayjs): string[] => {
  const today = inputDate ? dayjs(inputDate) : dayjs();

  const currentYear = today.year();
  const previousYear = currentYear - 1;
  const nextYear = currentYear + 1;

  const april15 = dayjs(`${currentYear}-04-15`);
  const nov30 = dayjs(`${currentYear}-11-30`);
  const dec31 = dayjs(`${currentYear}-12-31`);

  // today <= April 15
  if (today.isBefore(april15.add(1, 'day'))) {
    return [String(previousYear), String(currentYear)];
  }

  // today > November 30 && today <= December 31
  if (today.isAfter(nov30) && today.isBefore(dec31.add(1, 'day'))) {
    return [String(currentYear), String(nextYear)];
  }

  return [String(currentYear)];
};
